export default "__VITE_ASSET__DGpwVHa7__"